import React from 'react';

interface CommunityIconProps {
  color?: string;
  className?: string;
  width?: number;
  height?: number;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export const CommunityIcon: React.FC<CommunityIconProps> = ({
  className = "",
  width = 24,
  height = 24,
  color = 'white'
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M18.124 7.75024C18.124 6.5895 17.3704 5.60113 16.3223 5.25561L16.6753 4.18774L17.0269 3.11987C18.9698 3.76042 20.374 5.58968 20.374 7.75024C20.3739 10.17 18.6127 12.1762 16.3018 12.5593C15.6889 12.6609 15.1085 12.2464 15.0068 11.6335C14.9053 11.0208 15.3201 10.442 15.9326 10.3401C17.1758 10.1341 18.1239 9.05156 18.124 7.75024ZM15.606 3.83618C15.8005 3.2461 16.4368 2.92535 17.0269 3.11987L16.3223 5.25561C15.7326 5.06102 15.4119 4.42595 15.606 3.83618ZM23.125 19.2859C23.1249 20.3016 22.3009 21.1243 21.2852 21.1243H20.0005C19.3792 21.1243 18.8755 20.6206 18.8755 19.9993C18.8759 19.3783 19.3794 18.8743 20.0005 18.8743H20.8457C20.6676 17.5065 19.617 16.4113 18.269 16.1731C17.6574 16.0648 17.2498 15.4811 17.3579 14.8694C17.4662 14.258 18.0487 13.8505 18.6602 13.9583C21.1971 14.4066 23.125 16.6199 23.125 19.2859Z" fill={color}/>
      <path d="M7.14307 16.125C5.01417 16.125 3.27616 17.781 3.13818 19.875H14.8613C14.7233 17.781 12.9853 16.125 10.8564 16.125H7.14307ZM12.125 7.24951C12.1247 5.52401 10.726 4.12526 9.00049 4.125C7.27476 4.125 5.87478 5.52385 5.87451 7.24951C5.87451 8.9754 7.2746 10.3755 9.00049 10.3755C10.7262 10.3752 12.125 8.97524 12.125 7.24951ZM17.1245 20.1431C17.1244 21.2377 16.2372 22.125 15.1426 22.125H2.85693C1.76239 22.1249 0.875113 21.2376 0.875 20.1431C0.875 16.6814 3.68142 13.875 7.14307 13.875H10.8564C14.3181 13.875 17.1245 16.6814 17.1245 20.1431ZM14.375 7.24951C14.375 10.2179 11.9688 12.6252 9.00049 12.6255C6.03196 12.6255 3.62451 10.218 3.62451 7.24951C3.62478 4.28121 6.03212 1.875 9.00049 1.875C11.9686 1.87526 14.3747 4.28137 14.375 7.24951Z" fill={color}/>
    </svg>
  );
}; 